import { getDatabase, ref, child, get, push, update } from "firebase/database";
import { getFirestore, collection, query, where, getDocs, doc, getDoc, setDoc, addDoc } from "firebase/firestore";
import { getStorage, ref as storageRef, getDownloadURL, uploadBytes } from 'firebase/storage';

/**
 * Get competitors from a champ
 * @param {String} champId 
 * @returns Array of competitors
 */
const getCompetitorsFromChamp = async (champId) => {

    const dbRef = ref(getDatabase());
    let snapshot = await get(child(dbRef, `champs/${champId}/competitors`))
    if (snapshot.exists()) {
        let competitors = snapshot.val();
        let competitorsList = []
        for (var prop in competitors) {
            if (!competitors[prop].wasDeleted) {
                let localObj = competitors[prop];
                localObj['__key'] = prop;
                competitorsList.push(localObj);
            }
        };

        // Order by faixa
        competitorsList.sort(function (a, b) { return (a.faixa > b.faixa) ? 1 : ((b.faixa > a.faixa) ? -1 : 0) });

        return competitorsList;
    } else {
        return [];
    }
}

/**
 * Get teams from competitors list
 * @param {Array} competitorsList 
 * @returns Teams array of all competitors 
 */
const getTeamsFromCompetitors = async (competitorsList) => {
    let teams = competitorsList.map(el => el.equipe);
    teams = [...new Set(teams)];
    return teams;
}

/**
 * Get all teams
 * @returns Array of all teams
 */
const getTeams = async () => {
    const db = getFirestore();
    const q = query(collection(db, "teams"), where('wasDeleted', '!=', true));
    const querySnapshot = await getDocs(q);

    let localArray = [];
    querySnapshot.forEach((team) => {
        let localTeam = team.data();
        localTeam.__key = team.id;
        localArray.push(localTeam)
    });

    return localArray;
}

/**
 * Add a team
 * @returns 
 */
const addATeam = async (team) => {
    const db = getFirestore();
    const dbRef = collection(db, 'teams');

    try {
        await addDoc(dbRef, team);
        return {
            message: 'Campeonato criado com sucesso',
        }
    } catch (err) {
        return {
            error: true,
            message: err.message,
        }
    }
}

/**
 * Update a team
 * @param {String} teamId 
 * @param {Object} teamToUpdate 
 * @returns 
 */
const updateATeam = async (teamId, teamToUpdate) => {
    const db = getFirestore();
    const dbRef = doc(db, 'teams', teamId)

    try {
        await setDoc(dbRef, teamToUpdate, { merge: true });

        return {
            message: 'Campeonato atualizado com sucesso',
        }
    } catch (err) {
        return {
            error: true,
            message: err.message,
        }
    }
}

/**
 * Delete a team
 * @param {String} teamId 
 * @returns null
 */
const deleteATeam = async (teamId) => {
    try {
        const db = getFirestore();
        const dbRef = doc(db, 'teams', teamId);
        await setDoc(dbRef, { wasDeleted: true }, { merge: true });
        return true;
    } catch (e) {
        return false;
    }
}

/**
 * Get weight chart
 * @returns Weight chart array
 */
const getWeightChart = async () => {
    const db = getFirestore();
    const docRef = doc(db, "weightChartRev01", "weightChart");
    const docSnap = await getDoc(docRef);

    if (!docSnap.exists()) return null
    return docSnap.data();
}

/**
 * Add a competitor in a champ
 * @param {String} champId 
 * @param {String} competitor 
 * @returns Competitor added in champ
 */
const addCompetitor = async (champId, competitor) => {
    const dbRef = ref(getDatabase());
    const studentRef = child(dbRef, 'champs/' + champId + '/competitors');
    const studentAddedInChamp = await push(studentRef, competitor);
    return studentAddedInChamp;
}

/**
 * Add a participant in a event
 * @param {String} eventId 
 * @param {String} participant 
 * @returns Participant added in event
 */
const addEventParticipant = async (eventId, participant) => {
    const dbRef = ref(getDatabase());
    const studentRef = child(dbRef, 'events/' + eventId + '/students');
    const studentAddedInEvent = await push(studentRef, participant);
    return studentAddedInEvent;
}

/**
 * Add a competitor payment check file
 * @param {String} competitorId 
 * @param {Blob} file 
 */
const addPaymentCheckPhoto = async (competitorId, file) => {
    const storage = getStorage();
    let imageRef = storageRef(storage, 'studentsProfilePhotos/' + competitorId);
    await uploadBytes(imageRef, file);
}

/**
 * Get payment check photo url
 * @param {String} competitorId 
 * @returns Url of competitor payment check
 */
const getPaymentCheckPhotoUrl = async (competitorId) => {
    const storage = getStorage();
    let imageRef = storageRef(storage, 'studentsProfilePhotos/' + competitorId);
    let url = await getDownloadURL(imageRef);
    return url;
}

/**
 * Update competitor info
 * @param {String} champId 
 * @param {String} competitorId 
 * @param {Object} competitorUpdatedInfo 
 */
const updateCompetitor = async (champId, competitorId, competitorUpdatedInfo) => {
    const dbRef = ref(getDatabase());
    await update(child(dbRef, '/champs/' + champId + '/competitors/' + competitorId), competitorUpdatedInfo);
}

/**
 * Update participant info
 * @param {String} eventId 
 * @param {String} participantId 
 * @param {Object} participantUpdatedInfo 
 */
const updateEventParticipant = async (eventId, participantId, participantUpdatedInfo) => {
    const dbRef = ref(getDatabase());
    await update(child(dbRef, '/events/' + eventId + '/students/' + participantId), participantUpdatedInfo);
}

export {
    getCompetitorsFromChamp,

    getTeamsFromCompetitors,
    getTeams,
    addATeam,
    updateATeam,
    deleteATeam,

    getWeightChart,

    addCompetitor,
    addPaymentCheckPhoto,
    getPaymentCheckPhotoUrl,
    updateCompetitor,

    addEventParticipant,
    updateEventParticipant,
}